import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76f9fe5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "feedback-box" }
const _hoisted_2 = { class: "feedback-box__body" }
const _hoisted_3 = { class: "feedback-box__content" }
const _hoisted_4 = { class: "flex justify-evenly" }

import { FaceSmileIcon, FaceFrownIcon } from '@heroicons/vue/24/solid'
import FaceSmileIconOutline from '@heroicons/vue/24/outline/FaceSmileIcon'
import FaceFrownIconOutline from '@heroicons/vue/24/outline/FaceFrownIcon'
import { useI18n } from 'vue-i18n'
import { useToggle } from '@vueuse/core'

export default /*#__PURE__*/_defineComponent({
  __name: 'FeedbackHelpRequest',
  emits: ['complete', 'not-working'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const [sadActive, toggleSad] = useToggle()
const [smiledActive, toggleSmile] = useToggle()

const { t } = useI18n()

const onClickProblem = () => {
  emit('not-working')
}

const onClickComplete = () => {
  emit('complete')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_unref(t)('feedback-help-request.content')), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "icon",
          onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_unref(toggleSad)(true))),
          onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_unref(toggleSad)(false))),
          onClick: onClickProblem
        }, [
          _withDirectives(_createVNode(_unref(FaceFrownIconOutline), {
            class: "h-12 w-12 text-gray-400",
            "aria-hidden": "true"
          }, null, 512), [
            [_vShow, !_unref(sadActive)]
          ]),
          _withDirectives(_createVNode(_unref(FaceFrownIcon), {
            class: "h-12 w-12 text-red-600",
            "aria-hidden": "true"
          }, null, 512), [
            [_vShow, _unref(sadActive)]
          ])
        ], 32),
        _createElementVNode("div", {
          class: "icon",
          onMouseover: _cache[2] || (_cache[2] = ($event: any) => (_unref(toggleSmile)(true))),
          onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_unref(toggleSmile)(false))),
          onClick: onClickComplete
        }, [
          _withDirectives(_createVNode(_unref(FaceSmileIconOutline), {
            class: "h-12 w-12 text-gray-400",
            "aria-hidden": "true"
          }, null, 512), [
            [_vShow, !_unref(smiledActive)]
          ]),
          _withDirectives(_createVNode(_unref(FaceSmileIcon), {
            class: "h-12 w-12 text-green-500",
            "aria-hidden": "true"
          }, null, 512), [
            [_vShow, _unref(smiledActive)]
          ])
        ], 32)
      ])
    ])
  ]))
}
}

})